<template>
  <div :class="'custom_input wysiwyg '+width">
    <div class="label">
      {{ capitalisedLabel }}
    </div>
    <textarea id="trumbowyg" />
    <small
      v-for="(error, index) in validationErrors"
      :key="index"
      class="validation"
    >
      {{ error }}
    </small>
  </div>
</template>
<script>

import _ from 'lodash';
import $ from 'jquery';
import 'trumbowyg';
import 'trumbowyg/dist/plugins/colors/trumbowyg.colors.min.js';
import 'trumbowyg/dist/plugins/fontfamily/trumbowyg.fontfamily.min.js';
import 'trumbowyg/dist/plugins/fontsize/trumbowyg.fontsize.min.js';
import svgIcons from 'trumbowyg/dist/ui/icons.svg';
import {mapState} from 'vuex';

export default {
  props: {
    label: {
      type: String,
      required: true
    },
    modelValue: {
      type: String,
      required: false,
      default: null
    },
    width: {
      type: String,
      required: false,
      default: 'full'
    },
    validationErrors: {
      type: Object,
      required: false,
      default: null,
    }
  },
  emits: ['update:modelValue'],
  data() {
    return {
      font: 'DM Sans, sans-serif'
    }
  },
  computed: {
    ...mapState('report', ['report']),
    capitalisedLabel() {
      let words = this.label.split(' ');
      _.each(words, (word, index) => {
        words[index] = _.capitalize(word);
      });
      return words.join(' ');
    }
  },
  mounted() {
    if (this.report) {
      this.font = this.report.font;
    }
    // Prep and init Trumbowyg
    $.trumbowyg.svgPath = svgIcons;
    $('#trumbowyg').trumbowyg({
      resetCss: false,
      removeformatPasted: true,
      btns: [
        ['strong', 'em', 'del', 'underline'],
        ['justifyLeft', 'justifyCenter', 'justifyRight', 'justifyFull'],
        ['unorderedList', 'orderedList'],
        ['horizontalRule'],
        ['link'],
        ['foreColor', 'fontfamily', 'fontsize'],
        ['removeformat'],
        ['fullscreen']
      ],
      plugins: {
        colors: {
          colorList: [
            '040707', '0074D9', '7FDBFF', '39CCCC', 'B10DC9', 'F012BE', '85144b', 'FF4136', 'FF851B', 'FFDC00', '3D9970', '2ECC40', '01FF70', 'AAA', 'DDD', 'FFF'
          ]
        },
        fontfamily: {
          fontList: [
            {name: 'DM Sans', family: 'DM Sans, sans-serif'},
            {name: 'Arial', family: 'Arial, Helvetica, sans-serif'},
            {name: 'Cambria', family: 'Cambria, Cochin, Georgia, Times, Times New Roman, serif'},
            {name: 'Courier New', family: 'Courier New, Courier, monospace'},
            {name: 'Franklin Gothic Medium', family: 'Franklin Gothic Medium, Arial Narrow, Arial, sans-serif'},
            {
              name: 'Lucida Sans',
              family: 'Lucida Sans, Lucida Sans Regular, Lucida Grande, Lucida Sans Unicode, Geneva, Verdana, sans-serif'
            },
            {
              name: 'Roboto',
              family: 'Roboto, -apple-system, system-ui, BlinkMacSystemFont, Segoe UI, Helvetica Neue, Arial, sans-serif'
            },
            {name: 'Times New Roman', family: 'Times New Roman, Times, serif'},
          ]
        }
      }
    })
        .on('tbwchange', () => {
          this.$emit('update:modelValue', $('#trumbowyg').trumbowyg('html'));
        });
    $('#trumbowyg').trumbowyg('html', this.modelValue);
  },
  beforeUnmount() {
    if (this.el) {
      this.el.trumbowyg('destroy');
      this.el = null;
    }
  },
};
</script>
<style scoped>
@import "trumbowyg/dist/ui/trumbowyg.min.css";
@import "trumbowyg/dist/plugins/colors/ui/trumbowyg.colors.min.css";

.full {
  width: 100%;
}

.two-thirds {
  width: calc(66.66% - .5rem);
}

.half {
  width: calc(50% - .5rem);
}

.third {
  width: calc(33.33% - .5rem);
}

.quarter {
  width: calc(25% - .5rem);
}

.label {
  font-size: 0.75rem;
  line-height: 1.3;
  letter-spacing: -0.1px;
  color: #909096;
}

.validation {
  text-align: center;
  color: red;
  margin-left: 10px;
}

.trumbowyg-editor ol, .trumbowyg-editor ul {
  list-style: initial;
  padding: unset;
  padding-inline-start: 40px;
}

.trumbowyg-editor ul {
  list-style-type: disc;
  list-style-position: inside;
  line-height: 1.9;
  color: #455560;
}

.trumbowyg-editor ol {
  list-style-type: decimal;
  list-style-position: inside;
  line-height: 1.9;
  color: #455560;
}

.custom_input .wysiwyg {
  font-family: v-bind('font');
}

.trumbowyg-editor p {
  font-family: inherit !important;
}
</style>
